@if (kpi.newCompaniesState()) {
  <div class="container-fluid">
    <h1>{{header}}</h1>
  
    <div class="row banner-row">
      <div class="banner-logo">
        <img src="assets/images/sb1-logo-big.svg" alt="Banner logo">
      </div>
      <div class="col banner-today">
        <div class="banner-data">
          <span>Nye i dag</span>
          <span class="banner-value">{{bannerData()?.NewCompaniesToday | numberFormatPipe}}</span>
        </div>
      </div>
      <div class="col">
        <div class="banner-data">
          <span>Nye denne måneden</span>
          <span class="banner-value">{{bannerData()?.NewCompaniesThisMonth | numberFormatPipe}}</span>
        </div>
      </div>
      <div class="col">
        <div class="banner-data">
          <span>Nye forrige måned</span>
          <span class="banner-value">{{bannerData()?.NewCompaniesLastMonth | numberFormatPipe}}</span>
        </div>
      </div>
      <div class="col">
        <div class="banner-data">
          <span>Nye i {{currentYear}}</span>
          <span class="banner-value">{{bannerData()?.NewCompaniesThisYear | numberFormatPipe}}</span>
        </div>
      </div>
      <div class="col">
        <div class="banner-data">
          <span>Totalt antall selskap</span>
          <span class="banner-value">{{bannerData()?.Total | numberFormatPipe}}</span>
        </div>
      </div>
    </div>
    
    @if (tableData()?.length > 1) {
      <h1>Oversikt alle banker</h1>
      <div class="row table-container">
        <table class="kpi-table">
          <thead>
            <tr>
              <th width="1%"></th>
              <th width="19%"></th>
              <th width="16%" class="center">I dag</th>
              <th width="16%" class="center">Denne måneden</th>
              <th width="16%" class="center">Forrige måned</th>
              <th width="16%" class="center">I år</th>
              <th width="16%" class="center">Totalt</th>
            </tr>
          </thead>  
  
          <tbody>
            @for (envWidget of tableData(); track $index) {
              <tr class="child-row">
                <td></td>
                <td>
                  {{ envWidget.environment | environmentPipe }}
                </td>
                <td class="center">
                  {{envWidget.data[companyType]?.NewCompaniesToday | numberFormatPipe}}
                </td>
                <td class="center">
                  {{envWidget.data[companyType]?.NewCompaniesThisMonth | numberFormatPipe}}
                </td>
                <td class="center">
                  {{envWidget.data[companyType]?.NewCompaniesLastMonth | numberFormatPipe}}
                </td>
                <td class="center">
                  {{envWidget.data[companyType]?.NewCompaniesThisYear | numberFormatPipe}}
                </td>
                <td class="center">
                  {{envWidget.data[companyType]?.Total | numberFormatPipe}}
                </td>
              </tr>
            }
          </tbody>
          
        </table>
      </div>
    } @else {
      <div>empty</div>
    }
  </div>
}
